import { Result } from '@/common/data.service';
import { EnvironmentService } from '@/services/environment/environment.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SectionWWW } from '@/_store/general/general.types';

@Injectable({
	providedIn: 'root',
})
export class GeneralApiService {
	private readonly environmentService = inject(EnvironmentService);
	private readonly httpClient = inject(HttpClient);
	private readonly api: string = this.environmentService.environment.apiUrl;

	getSectionWWW(): Observable<Result<SectionWWW>> {
		return this.httpClient.get<Result<SectionWWW>>(`${this.api}www/section_www/`);
	}
}
